/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable import/named */
/* eslint-disable  */
import Cookies from 'js-cookie';
import React, { lazy } from 'react';
//import crypto from "crypto";
import CryptoJS from 'crypto-js';
import PersonIcon from '@material-ui/icons/Person';
import CommunityList from '../screens/Main/CommunityList/CommunityList';
import CommunityDetails from '../screens/Main/CommunityDetails/CommunityDetails';
import CommunityEditViewAbout from '../screens/Main/CommunityDetails/CommunityEditViewAbout';
import CommunityUpdateCoverPhoto from '../screens/Main/CommunityCoverPhoto/CommunityUpdateCoverPhoto';
import CommunityEditViewResidents from '../screens/Main/CommunityDetails/CommunityEditViewResidents';
import CommunityEditViewClimate from '../screens/Main/CommunityDetails/CommunityEditViewClimate';
import CommunityEditViewGettingAround from '../screens/Main/CommunityDetails/CommunityEditViewGettingAround';
import CommunityEditViewEducation from '../screens/Main/CommunityDetails/CommunityEditViewEducation';
import CommunityAddHealthFacility from '../screens/Main/CommunityDetails/CommunityAddHealthFacility';

import CommunityEditviewAmenities from '../screens/Main/CommunityDetails/CommunityEditViewAmenities';
import CommunityEditViewClubs from '../screens/Main/CommunityDetails/CommunityEditViewClubs';
import CommunityEditViewClubsConnectionsInsight from '../screens/Main/CommunityDetails/CommunityEditViewClubsConnectionsInsight/CommunityEditViewClubsConnectionsInsight';
import CommunityEditViewAddNewAmenity from '../screens/Main/CommunityDetails/CommunityEditViewAddNewAmenity';
import CommunityEditViewForCommunityReps from '../screens/Main/CommunityDetails/CommunityEditViewForCommunityReps/CommunityEditViewForCommunityReps';
import CreateClubConnection from '../screens/Main/ClubsAndConnections/CreateClubConnection';

import CommunityEditViewJobs from '../screens/Main/CommunityDetails/CommunityEditViewJobs/CommunityEditViewJobs';
import ViewAllAmenities from '../screens/Main/CommunityDetails/ViewAllAmenities/ViewAllAmenities';
import CommunityHealthInsights from '../screens/Main/CommunityDetails/CommunityHealthInsights/CommunityHealthInsights';
import CommunityHealthFacility from '../screens/Main/CommunityDetails/CommunityHealthFacility/CommunityHealthFacility';

import Invitation from '../screens/Main/Invitation/Invitation';
import InvitationLinkExpired from '../screens/Main/Invitation/InvitationLinkExpired';
import OnboardingConfirmation from '../screens/Main/Invitation/OnboardingConfirmation';
import LeaveCommunity from '../screens/Main/LeaveCommunity/LeaveCommunity';
import DeclineInvitationSuccess from '../screens/Main/Invitation/DeclineInvitationSuccess';
import JobList from '../screens/Main/JobList/JobList';
import CommunityEditViewCostOfLiving from '../screens/Main/CommunityDetails/CommunityEditViewCostOfLiving/CommunityEditViewCostOfLiving';
import AdminEditApproval from '../screens/Main/AboutCommunity/AdminEditApproval';
import AdminRejection from '../screens/Main/AboutCommunity/AdminRejection';
import AdminEditRejection from '../screens/Main/AboutCommunity/AdminEditRejection';
import ClubCommunityAll from '../screens/Main/ClubsNew/ClubCommunityAll';
import ViewAllClub from '../screens/Main/ClubsNew/ViewAllClub';
import CommunityEditViewAddNewClub from '../screens/Main/CommunityDetails/CommunityEditViewAddNewAmenity/CommunityEditViewAddNewClub';
import PrivacyNotice from '../screens/Main/PrivacyNotice/PrivacyNotice';
import TermsOfUse from '../screens/Main/TermsOfUse/TermsOfUse';

let userType = '';
let appNavData = [];
const EditUserAccount = lazy(() => import('../screens/Main/Account/EditUserAccount'));
const Account = lazy(() => import('../screens/Main/Account'));
const EditAccount = lazy(() => import('../screens/Main/EditAccount'));

const HomeIn = lazy(() => import('../screens/Main/HomeIn'));
const ForgotPassword = lazy(() => import('../screens/Auth/ForgotPassword'));
const CheckYourEmail = lazy(() => import('../screens/Auth/CheckYourEmail'));
const EditEmail = lazy(() => import('../screens/Main/EditEmail'));

const EditPassword = lazy(() => import('../screens/Main/EditPassword'));

const ResetPassword = lazy(() => import('../screens/Auth/ResetPassword'));
const DeleteAccount = lazy(() => import('../screens/Auth/DeleteAccount'));
const DeleteAccountSuccess = lazy(() => import('../screens/Auth/DeleteAccountSuccess'));
const HomePage = lazy(() => import('../screens/Main/HomePage/HomePage'));
const FindYourHappy = lazy(() => import('../screens/Main/FindYourHappy/FindYourHappy'));
const ChangeEmailSent = lazy(() => import('../screens/Auth/ChangeEmailSent/ChangeEmailSent'));
const ComingSoon = lazy(() => import('../screens/Main/ComingSoon/ComingSoon'));
const NoFound = lazy(() => import('../screens/NotFound/NoFound'));
const VerifyChangeEmail = lazy(() => import('../screens/Auth/VerifyChangeEmail/VerifyChangeEmail'));
const JobDetails = lazy(() => import('../screens/Main/JobDetails/JobDetails'));
const AdminApproval = lazy(() => import('../screens/Main/AboutCommunity/AdminApproval'));
const AdministrativeCenter = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/AdministrativeCenter'),
);
const EditUserDetails = lazy(() => import('../screens/Auth/AdministrativeCenter/EditUserDetails'));
const ChangeAccountType = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/ChangeAccountType'),
);
const CreateNewCommunity = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/CreateNewCommunity'),
);
const AdminVideoReview = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/AdminVideoReview'),
);
const AdminVideoDeny = lazy(() => import('../screens/Auth/AdministrativeCenter/AdminVideoDeny'));
const AdminCreateNewCommunity = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/AdminCreateNewCommunity'),
);
const InviteCommunityRepresentative = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/InviteCommunityRepresentative'),
);
const AddAmenityData = lazy(() => import('../screens/Auth/AdministrativeCenter/AddAmenityData'));
const EditAmenityData = lazy(() => import('../screens/Auth/AdministrativeCenter/EditAmenityData'));

const DeclineInvitation = lazy(() => import('../screens/Main/Invitation/DeclineInvitation'));
const DeclineInviteInfo = lazy(() =>
  import('../screens/Auth/AdministrativeCenter/DeclineInviteInfo'),
);

// const Settings = lazy(() => import('../screens/Main/Settings'));
const key = 'iFrasCwdJh';

const userCookie = Cookies.get('user');

if (userCookie) {
  //const userData = JSON.parse(atob(userCookie));
  //const userData = crypto.createDecipher('aes-256-ctr', key).update(userCookie, 'hex', 'utf-8');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const userData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  userType = (userData.userType && userData.userType.type) || null;
  // navigate('../../app/account');
  // console.log(1111, 'A1');
} else {
  // console.log(1111, 'B1');
  /* if (window.location.href.indexOf('verify') < 0) {
    console.log(1111, 'C1');
    window.location = '#/app/home-page';
  } else  */
  if (
    window.location.hash === '' ||
    window.location.hash === '/#' ||
    window.location.hash === '#/'
  ) {
    // console.log(1111, 'C2');
    window.location.hash = '#/app/home-page';
  }
}
// else {
//   // if (
//   //   window.location.href.indexOf('set-password') < 0 &&
//   //   window.location.href.indexOf('forgot-password') < 0 &&
//   //   window.location.href.indexOf('reset-password') < 0 &&
//   //   window.location.href.indexOf('practice-account/create-account') < 0 &&
//   //   window.location.href.indexOf('addusers') < 0 &&
//   //   window.location.href.indexOf('create-account') < 0 &&
//   //   window.location.href.indexOf('practice-account/payment') < 0
//   // )
//   // {
//     // window.location = '/#/login';
//     /*to pass no authorization urls*/
//     let noAuthUrls = ['dialogstable', 'CommunityList']; // add urls here to access without auth
//     let urlIndex = noAuthUrls.filter((responses) => window.location.href.indexOf(responses) > -1);
//     /*to pass no authorization urls*/

//     if (!urlIndex || !urlIndex.length) {
//       console.log('RRR');
//       window.location = '/#/app/home-page';
//     } else {
//       appNavData = [
//         // {
//         //   name: 'Dialogs Table',
//         //   /* navImage: require('../assets/images/staff.png').default, */
//         //   image: require('../assets/images/staff.png').default,
//         //   navIcons: <TestIconActive />,
//         //   path: 'dialogstable',
//         //   element: null,
//         //   navIconsAlt: <TestIcon />,
//         // },
//       ];
//     // }
//   }
// }
appNavData = [
  // {
  //   name: 'Landing',
  //   path: '',
  //   element: <WaterMark />,
  // },

  {
    navIcons: <AdministrativeCenter />,
    path: 'admin-center',
    element: <AdministrativeCenter />,
    navIconsAlt: <AdministrativeCenter />,
    num: -1,
  },
  {
    navIcons: <AdminVideoReview />,
    path: 'admin-video-review/:communityName/:communityVideoId',
    element: <AdminVideoReview />,
    navIconsAlt: <AdminVideoReview />,
    num: -1,
  },
  {
    navIcons: <AdminVideoDeny />,
    path: 'admin-video-deny/:communityName/:communityVideoId',
    element: <AdminVideoDeny />,
    navIconsAlt: <AdminVideoDeny />,
    num: -1,
  },

  {
    navIcons: <AdministrativeCenter />,
    path: 'admin-center/:tab1/:tab2',
    element: <AdministrativeCenter />,
    navIconsAlt: <AdministrativeCenter />,
    num: -1,
  },
  {
    navIcons: <EditUserDetails />,
    path: 'edit-user-details',
    element: <EditUserDetails />,
    navIconsAlt: <EditUserDetails />,
    num: -1,
  },
  {
    navIcons: <ChangeAccountType />,
    path: 'change-account-type/:userId',
    element: <ChangeAccountType />,
    navIconsAlt: <ChangeAccountType />,
    num: -1,
  },
  {
    navIcons: <CreateNewCommunity />,
    path: 'create-new-community',
    element: <CreateNewCommunity />,
    navIconsAlt: <CreateNewCommunity />,
    num: -1,
  },
  {
    navIcons: <AdminCreateNewCommunity />,
    path: 'admin-create-community/:communityId',
    element: <AdminCreateNewCommunity />,
    navIconsAlt: <AdminCreateNewCommunity />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'invite-community-representative',
    element: <InviteCommunityRepresentative />,
    navIconsAlt: <InviteCommunityRepresentative />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'add-amenities-data',
    element: <AddAmenityData />,
    navIconsAlt: <AddAmenityData />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'add-healthcare-data',
    element: <AddAmenityData />,
    navIconsAlt: <AddAmenityData />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'edit-amenities-data',
    element: <EditAmenityData />,
    navIconsAlt: <EditAmenityData />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'edit-healthcare-data',
    element: <EditAmenityData />,
    navIconsAlt: <EditAmenityData />,
    num: -1,
  },

  {
    navIcons: <PersonIcon />,
    path: 'invite-community-representative/:inviteCommunityId',
    element: <InviteCommunityRepresentative />,
    navIconsAlt: <InviteCommunityRepresentative />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'home-in',
    element: <HomeIn />,
    navIconsAlt: <PersonIcon />,
    num: 2,
  },
  {
    navIcons: <PersonIcon />,
    path: 'home-page',
    element: <HomePage />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'find-your-happy',
    element: <FindYourHappy />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'privacy-notice',
    element: <PrivacyNotice />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'terms-of-use',
    element: <TermsOfUse />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'community-list',
    name: 'CommunityList',
    element: <CommunityList />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'find-your-happy',
    name: 'FindYourHappy',
    element: <ComingSoon />,
    navIconsAlt: <PersonIcon />,
    num: 2,
  },
  {
    navIcons: <PersonIcon />,
    path: 'not-found',
    name: 'Not Found',
    element: <NoFound />,
    navIconsAlt: <PersonIcon />,
    num: 2,
  },
  {
    navIcons: <ForgotPassword />,
    path: 'forgot-password',
    element: <ForgotPassword />,
    navIconsAlt: <ForgotPassword />,
    num: -1,
  },
  {
    navIcons: <EditEmail />,
    path: 'edit-email',
    element: <EditEmail />,
    navIconsAlt: <EditEmail />,
    num: -1,
  },
  {
    path: 'change-email-sent',
    element: <ChangeEmailSent />,
  },
  {
    path: 'verify-change-email-token/:token',
    element: <VerifyChangeEmail />,
  },
  {
    navIcons: <EditPassword />,
    path: 'edit-password',
    element: <EditPassword />,
    navIconsAlt: <EditPassword />,
    num: -1,
  },
  {
    navIcons: <ResetPassword />,
    path: 'reset-password/:token',
    element: <ResetPassword />,
    navIconsAlt: <ResetPassword />,
    num: -1,
  },
  {
    navIcons: <DeleteAccount />,
    path: 'delete-account/:id',
    element: <DeleteAccount />,
    navIconsAlt: <DeleteAccount />,
    num: -1,
  },
  {
    navIcons: <DeleteAccountSuccess />,
    path: 'delete-account-success',
    element: <DeleteAccountSuccess />,
    navIconsAlt: <DeleteAccountSuccess />,
    num: -1,
  },
  {
    name: 'CommunityDetails',
    path: 'community-details/:id',
    navIcons: <PersonIcon />,
    element: <CommunityDetails />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditviewResidents',
    path: 'community-details-edit-residents/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewResidents />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditviewClimate',
    path: 'community-details-edit-climate/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewClimate />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditviewClimate',
    path: 'community-details-edit-cost-of-living/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewCostOfLiving />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },

  {
    name: 'CommunityEditViewForCommunityReps',
    path: 'community-details-edit-community-reps/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewForCommunityReps />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityHealthInsights',
    path: 'community-details-health-insights/:id',
    navIcons: <PersonIcon />,
    element: <CommunityHealthInsights />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityHealthInsights',
    path: 'community-details-health-facilities/:id',
    navIcons: <PersonIcon />,
    element: <CommunityHealthFacility />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditviewGettingAround',
    path: 'community-details-edit-getting-around/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewGettingAround />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditviewEducation',
    path: 'community-details-edit-education/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewEducation />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityAddHealthFacility',
    path: 'community-add-health-facility/:id',
    navIcons: <PersonIcon />,
    element: <CommunityAddHealthFacility />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityAddHealthFacility',
    path: 'community-edit-health-facility/:id/:facilityId',
    navIcons: <PersonIcon />,
    element: <CommunityAddHealthFacility />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  /* {
    name: 'CommunityDetailPublicView',
    path: 'community-details-publicview/:id',
    navIcons: <PersonIcon />,
    element: <CommunityDetailPublicView />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  }, */
  {
    name: 'CommunityEditViewAddNewAmenity',
    path: 'community-details-update-cover-photo/:id',
    navIcons: <PersonIcon />,
    element: <CommunityUpdateCoverPhoto />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewAddNewClub',
    path: 'community-details-edit-add-new-club/:from/:id/:amenityId',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewAddNewClub />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewAbout',
    path: 'community-details-edit-about/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewAbout />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewAbout',
    path: 'video-upload-request/:requestId',
    navIcons: <PersonIcon />,
    element: <AdminApproval />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewAbout',
    path: 'video-reject-request/:requestId',
    navIcons: <PersonIcon />,
    element: <AdminRejection />,
    navIconsAlt: <PersonIcon />,
    num: 1,
    header: false,
    footer: false,
  },
  {
    name: 'CommunityEditViewAbout',
    path: 'approve-edit-video-request/:requestId',
    navIcons: <PersonIcon />,
    element: <AdminEditApproval />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewAbout',
    path: 'reject-edit-video-request/:requestId',
    navIcons: <PersonIcon />,
    element: <AdminEditRejection />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewJobs',
    path: 'community-details-edit-jobs/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewJobs />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'ViewAllAmenities',
    path: 'view-all-amenities/:id',
    navIcons: <PersonIcon />,
    element: <ViewAllAmenities />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'ClubCommunityAll',
    path: 'club-community-all/:id',
    navIcons: <PersonIcon />,
    element: <ViewAllClub />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'JobList',
    path: 'job-list/:id',
    navIcons: <PersonIcon />,
    element: <JobList />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'JobDetails',
    path: 'job-details/:communityId/:jobId/:employerId',
    navIcons: <PersonIcon />,
    element: <JobDetails />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditviewAmenities',
    path: 'community-details-edit-amenities/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditviewAmenities />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewClubs',
    path: 'community-details-edit-clubs/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewClubs />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewClubsConnectionsInsight',
    path: 'community-details-edit-clubs-connections-insight/:id',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewClubsConnectionsInsight />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CommunityEditViewAddNewAmenity',
    path: 'community-details-edit-add-new-amenity/:from/:id/:amenityId',
    navIcons: <PersonIcon />,
    element: <CommunityEditViewAddNewAmenity />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    name: 'CreateClubConnection',
    path: 'create-club-connection/:id',
    navIcons: <PersonIcon />,
    element: <CreateClubConnection />,
    navIconsAlt: <PersonIcon />,
    num: 1,
  },
  {
    navIcons: <CheckYourEmail />,
    path: 'check-your-email',
    element: <CheckYourEmail />,
    navIconsAlt: <CheckYourEmail />,
    num: -1,
  },

  {
    path: 'invitation/:invitationId',
    name: 'invitation',
    navIcons: <PersonIcon />,
    element: <Invitation />,
    navIconsAlt: <PersonIcon />,
    num: -1,
    header: false,
    footer: false,
  },
  {
    path: 'invitation-link-expired',
    name: 'invitation-link-expired',
    navIcons: <PersonIcon />,
    element: <InvitationLinkExpired />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
  {
    path: 'invitation-link-expired/:reason',
    name: 'invitation-link-expired',
    navIcons: <PersonIcon />,
    element: <InvitationLinkExpired />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
  {
    path: 'onboarding-confirmation/:invitationId',
    name: 'Onboarding Confirmation',
    navIcons: <PersonIcon />,
    element: <OnboardingConfirmation />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },

  {
    navIcons: <PersonIcon />,
    path: 'decline-Invitation-success',
    element: <DeclineInvitationSuccess />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'decline-invitation/:id',
    element: <DeclineInvitation />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'decline-invite-info/:id',
    element: <DeclineInviteInfo />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'decline-invitation-success',
    element: <DeclineInvitationSuccess />,
    num: -1,
  },
  {
    navIcons: <PersonIcon />,
    path: 'leave-community/:id',
    element: <LeaveCommunity />,
    num: -1,
  },
  {
    name: 'Account',

    navIcons: <PersonIcon />,
    path: 'account',
    element: <Account />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
  {
    name: 'EditUserAccount',
    navIcons: <PersonIcon />,
    path: 'edit-user-account/:userId',
    element: <EditUserAccount />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
  {
    name: 'EditAccount',
    navIcons: <PersonIcon />,
    path: 'editaccount',
    element: <EditAccount />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
  {
    name: 'EditAccountAdmin',
    navIcons: <PersonIcon />,
    path: 'edit-account-admin/:userId',
    element: <EditAccount />,
    navIconsAlt: <PersonIcon />,
    num: -1,
  },
];
const appNav = appNavData;
export default appNav;
